import { isObject } from "@helpers/is-object.helper";

export const GenericActionKeys = {
	APP_STARTED: { label: "APP_STARTED", sensitive: false }, // empty
	EMAIL_VERIFIED: { label: "EMAIL_VERIFIED", sensitive: false },
	EMAIL_RESEND: { label: "EMAIL_RESEND", sensitive: false },
	EMAIL_UPDATE: { label: "EMAIL_UPDATE", sensitive: false },
	LOGOUT: { label: "LOGOUT", sensitive: false },
	APP_RESET: { label: "APP_RESET", sensitive: false },
	LOGIN_SUCCESS: { label: "LOGIN_SUCCESS", sensitive: false },
	LOGIN_FAILURE: { label: "LOGIN_FAILURE", sensitive: false },
};

export const NavigationActionKeys = {
	NAVIGATE: { label: "NAVIGATE", sensitive: false },
	POP: { label: "POP", sensitive: false },
};

export const MessagingActionKeys = {
	PUSH_NOTIFICATIONS_ACCEPTED: {
		label: "PUSH_NOTIFICATIONS_ACCEPTED",
		sensitive: true,
	},
	MESSAGE_RECEIVED: {
		label: "MESSAGE_RECEIVED",
		sensitive: true,
	},
};

export const RegisterActionKeys = {
	COMPLETE_REMINDME: {
		label: "COMPLETE_REMINDME",
		sensitive: false,
	},
	COMPLETE_REMINDME_FAILED: {
		label: "COMPLETE_REMINDME_FAILED",
		sensitive: false,
	},
	COMPLETE_FRIENDS_FAMILY: {
		label: "COMPLETE_FRIENDS_FAMILY",
		sensitive: false,
	},
	COMPLETE_LEAD_COLLECTION_FORM: {
		label: "COMPLETE_LEAD_COLLECTION_FORM",
		sensitive: false,
	},
};

export const BuyFlowActionKeys = {
	BUY_SET_PLAN: { label: "BUY_SET_PLAN", sensitive: false },
	BUY_IDD: { label: "BUY_IDD", sensitive: false },
	BUY_PROMO_CODE: { label: "BUY_PROMO_CODE", sensitive: false },
	BUY_PLAN_NAME: { label: "BUY_PLAN_NAME", sensitive: false },
	BUY_SET_FIRST_NAME: { label: "BUY_SET_FIRST_NAME", sensitive: true }, // string
	BUY_SET_LAST_NAME: { label: "BUY_SET_LAST_NAME", sensitive: true }, // string
	BUY_SET_KEEP_NUMBER: { label: "BUY_SET_KEEP_NUMBER", sensitive: false }, // bool
	BUY_SET_CURRENT_NUMBER: { label: "BUY_SET_CURRENT_NUMBER", sensitive: true }, // string
	BUY_SET_DOB: { label: "BUY_SET_DOB", sensitive: true }, // string
	BUY_SET_EMAIL: { label: "BUY_SET_EMAIL", sensitive: true }, // string
	BUY_SET_BRAZE_ID: { label: "BUY_SET_BRAZE_ID", sensitive: false },
	BUY_SET_PASSWORD: { label: "BUY_SET_PASSWORD", sensitive: true }, // string
	BUY_SET_RESIDENTIAL_ADDRESS: {
		label: "BUY_SET_RESIDENTIAL_ADDRESS",
		sensitive: true,
	}, // object
	BUY_SET_DELIVERY_ADDRESS: {
		label: "BUY_SET_DELIVERY_ADDRESS",
		sensitive: true,
	}, // object
	BUY_SET_DELIVERY_METHOD: {
		label: "BUY_SET_DELIVERY_METHOD",
		sensitive: false,
	}, // object
	BUY_SET_CREDIT_CARD: { label: "BUY_SET_CREDIT_CARD", sensitive: true }, // object
	BUY_SET_PAYPAL: { label: "BUY_SET_PAYPAL", sensitive: true }, // object
	BUY_SUBMIT: { label: "BUY_SUBMIT", sensitive: false },
	BUY_SET_ACCOUNT_ID: { label: "BUY_SET_ACCOUNT_ID", sensitive: false },
	BUY_SELECT_PRODUCT: { label: "BUY_SELECT_PRODUCT", sensitive: false },
	BUY_DESELECT_PRODUCT: { label: "BUY_DESELECT_PRODUCT", sensitive: false },
	BUY_SUCCESS: { label: "BUY_SUCCESS", sensitive: false },
	BUY_SET_SIM_TYPE: { label: "BUY_SET_SIM_TYPE", sensitive: false },
	BUY_SET_SIM_CHANNEL: { label: "BUY_SET_SIM_CHANNEL", sensitive: false },
	BUY_SET_SIM_CHANNEL_EVENT: {
		label: "BUY_SET_SIM_CHANNEL_EVENT",
		sensitive: false,
	},
	// BUY_SIM_DELIVERY_STATUS: { label: "BUY_SIM_DELIVERY_STATUS", sensitive: false },
	RETAIL_SIM_CONFIRMED: { label: "RETAIL_SIM_CONFIRMED", sensitive: false },
	BUY_INITIATE_PURCHASE: { label: "BUY_INITIATE_PURCHASE", sensitive: false },
};

export const GTMActionKeys = {
	FORM_START: { label: "FORM_START", sensitive: false },
	BUY_SET_SIM_CHANNEL: { label: "BUY_SET_SIM_CHANNEL", sensitive: false },
	FORM_ERROR: { label: "FORM_ERROR", sensitive: false },
	FORM_STEP_COMPLETE: { label: "FORM_STEP_COMPLETE", sensitive: false },
	FORM_SUBMIT_SUCCESS: { label: "FORM_SUBMIT_SUCCESS", sensitive: false },
	LIVE_CHAT_OPEN: { label: "LIVE_CHAT_OPEN", sensitive: false },
	CHECKOUT: { label: "CHECKOUT", sensitive: false },
	PURCHASE: { label: "PURCHASE", sensitive: false },
	CTA_CLICK: { label: "CTA_CLICK", sensitive: false },
	REQUEST_TIMEOUT: { label: "REQUEST_TIMEOUT", sensitive: false },
};

export const ActivateFlowActionKeys = {
	PORT_ACCOUNT_DOB: { label: "PORT_ACCOUNT_DOB", sensitive: true },
	PORT_ACCOUNT_ID: { label: "PORT_ACCOUNT_ID", sensitive: true },
	PORT_PLAN_TYPE: { label: "PORT_PLAN_TYPE", sensitive: false },
	ACTIVATE_SIM_CARD_NUMBER: {
		label: "ACTIVATE_SIM_CARD_NUMBER",
		sensitive: true,
	},
	ACTIVATE_SUBMIT: { label: "ACTIVATE_SUBMIT", sensitive: false },
	ACTIVATE_SUBMIT_FAIL: { label: "ACTIVATE_SUBMIT_FAIL", sensitive: false },
};

export const UseFlowActionKeys = {
	USE_ADD_INTL_ROAMING: { label: "USE_ADD_INTL_ROAMING", sensitive: false },
	USE_ADD_IDD: { label: "USE_ADD_IDD", sensitive: false },
	USE_PAUSE_PLAN: { label: "USE_PAUSE_PLAN", sensitive: false },
	USE_RESUME_PLAN: { label: "USE_RESUME_PLAN", sensitive: false },
	USE_CANCEL_PLAN: { label: "USE_CANCEL_PLAN", sensitive: false },
	USE_UPDATE_CREDIT_CARD: { label: "USE_UPDATE_CREDIT_CARD", sensitive: true },
	USE_REPURCHASE: { label: "USE_REPURCHASE", sensitive: false },
};

export const PerformanceActionKeys = {
	PERFORMANCE_TRACE_START: {
		label: "PERFORMANCE_TRACE_START",
		sensitive: false,
	}, // string
	PERFORMANCE_TRACE_END: { label: "PERFORMANCE_TRACE_END", sensitive: false }, // empty
};

export const ErrorActionKeys = {
	ERROR: { label: "ERROR", sensitive: false }, // object
};

const ActionKeyDefs = {
	...GenericActionKeys,
	...NavigationActionKeys,
	...RegisterActionKeys,
	...BuyFlowActionKeys,
	...ActivateFlowActionKeys,
	...ErrorActionKeys,
	...PerformanceActionKeys,
	...UseFlowActionKeys,
	...MessagingActionKeys,
};

interface IActionListenersMap {
	[key: string]: Array<Function>;
}

export interface IKeyDefValue {
	label: string;
	sensitive: boolean;
}

export interface IListenerHandle {
	remove: () => void;
}

let ActionListeners: IActionListenersMap = {};

const removeAllListener = () => {
	ActionListeners = {};
};

const isSensitive = (key: string): boolean => {
	const found = Object.values(ActionKeyDefs).filter((k) => k.label === key);
	if (found && found.length > 0) {
		return found[0].sensitive;
	}
	return false;
};

const trigger =
	<T = object>(actionKey: IKeyDefValue) =>
	(middlewareFns: Array<(actionKey: string, payload: Object) => any>) =>
	(params?: T) => {
		const payload = isObject(params)
			? params
			: params !== undefined
				? { value: params }
				: {};

		middlewareFns.forEach((fn) => {
			fn(actionKey.label, {
				actionKey,
				...payload,
			});
		});

		const listeners = ActionListeners[actionKey.label];

		if (!listeners) {
			return;
		}

		listeners.forEach((listener) => {
			listener({
				actionKey,
				...payload,
			});
		});
	};

const addListener = (
	actionKey: IKeyDefValue,
	fn: Function,
): IListenerHandle => {
	let idx = 0;
	if (ActionListeners[actionKey.label] === undefined) {
		ActionListeners[actionKey.label] = [fn];
	} else {
		idx = ActionListeners[actionKey.label].push(fn) - 1;
	}

	return {
		remove: (): void => {
			ActionListeners[actionKey.label].splice(idx, 1);
		},
	};
};

const addListenerToKeys =
	(keys: Array<IKeyDefValue> | Object) =>
	(fn: Function): Array<IListenerHandle> => {
		const keysArr = Array.isArray(keys) ? keys : Object.values(keys);
		return keysArr.map((actionKey) => addListener(actionKey, fn));
	};

const addListenerToAllKeysExcluding = (
	keysToExclude: Array<IKeyDefValue> | Object,
	fn: Function,
) => {
	const keysToExcludeArr = Array.isArray(keysToExclude)
		? keysToExclude
		: Object.values(keysToExclude);

	const keysToListenTo = Object.values(ActionKeyDefs).filter(
		(val) =>
			!keysToExcludeArr.some(
				(keyToExclude: IKeyDefValue): boolean =>
					keyToExclude.label === val.label,
			),
	);

	return addListenerToKeys(keysToListenTo)(fn);
};

export const Actioner = {
	keyDefs: ActionKeyDefs,
	isSensitive,
	trigger: (actionKey: IKeyDefValue, payload?: Object) => {
		trigger<Object>(actionKey)([])(
			payload
				? {
						...payload,
						transaction_id: self.crypto.randomUUID(),
					}
				: payload,
		);
	},
	addListener,
	addListenerToKeys,
	addListenerToAllKeys: addListenerToKeys(ActionKeyDefs),
	addListenerToAllKeysExcluding,
	addListenerToGenericKeys: addListenerToKeys(GenericActionKeys),
	addListenerToErrorKeys: addListenerToKeys(ErrorActionKeys),
	addListenerToBuyFlowKeys: addListenerToKeys(BuyFlowActionKeys),
	addListenerToActivateFlowKeys: addListenerToKeys(ActivateFlowActionKeys),
	addListenerToUseFlowKeys: addListenerToKeys(UseFlowActionKeys),
	addListenerToPerformanceKeys: addListenerToKeys(PerformanceActionKeys),
	addListenerToMessagingKeys: addListenerToKeys(MessagingActionKeys),
	addListenerToRegisterKeys: addListenerToKeys(RegisterActionKeys),
	removeAllListener,
};
